import React, { useState, useEffect, useCallback } from "react";
import Axios from "utils/Axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import MKDatePicker from "components/MKDatePicker";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import the Quill stylesheet
import fileUpload from "../../../../assets/images/file_upload.png";
import "./addEvent.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Modal, Button, Typography, Paper } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import dayjs from "dayjs";

// Time format validation is now handled by the MUI TimePicker

function AddNew() {
  const { id } = useParams(); // Extract the event ID from the URL
  const [eventTitle, setEventTitle] = useState("");
  const [eventDate, setEventDate] = useState(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    });
  const [eventTime, setEventTime] = useState(dayjs().set('hour', 22).set('minute', 0));
  const [eventPrice, setEventPrice] = useState("");
  const [venueName, setVenueName] = useState("");
  const [eventAddress, setEventAddress] = useState("");
  const [eventAddressUrl, setEventAddressUrl] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [eventCover, setEventCover] = useState(null);
  const [eventCoverPreview, setEventCoverPreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recentLocations, setRecentLocations] = useState([]);
  const [selectedCity, setSelectedCity] = useState(""); // State for selected city
  const [cities, setCities] = useState([]); // State for list of cities
  const [promoters, setPromoters] = useState([]);
  const [selectedPromoter, setSelectedPromoter] = useState("");
  const navigate = useNavigate();

  const validateURL = (url) => /^https?:\/\/[^\s$.?#].[^\s]*$/i.test(url);

  const handleOpenModal = () => {
    fetchUserLocations();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleSelectLocation = (location) => {
    setEventAddress(location.address);
    setEventAddressUrl(location.address_url);
    setVenueName(location.venue_name);
    handleCloseModal();
  };
  //fetch user locations
  const fetchUserLocations = () => {
    Axios.get(`?type=locations`)
      .then((response) => {
        setRecentLocations(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch user locations", error);
      })
      .finally(() => {
        setLoadingDelete(false);
      });
  };
  const deleteLocation = (location_id, idx) => {
    setLoadingDelete(true);
    setLoadingIndex(idx);
    Axios.post(`?type=locations`, {
      location_id,
    })
      .then(() => {
        fetchUserLocations();
      })
      .catch((error) => {
        console.log("failed to delete location", error);
      });
  };
  useEffect(() => {
    if (id) {
      // Fetch the event data if an ID is provided
      const getSingleEvent = () => {
        Axios.get(`?type=event&id=${id}`)
          .then((response) => {
            const data = response.data;
            setEventTitle(data.title);
            // Convert the string time to dayjs object
            const timeParts = data.time.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
            if (timeParts) {
              let hours = parseInt(timeParts[1]);
              const minutes = parseInt(timeParts[2]);
              const period = timeParts[3].toUpperCase();
              
              // Convert to 24-hour format for dayjs
              if (period === "PM" && hours < 12) hours += 12;
              if (period === "AM" && hours === 12) hours = 0;
              
              setEventTime(dayjs().set('hour', hours).set('minute', minutes));
            } else {
              setEventTime(dayjs().set('hour', 22).set('minute', 0));
            }
            setEventPrice(data.ticketPrice);
            setVenueName(data.venue_name);
            setEventAddress(data.location);
            setEventAddressUrl(data.location_url);
            setEventDescription(data.description);
            setSelectedCity(data.city_id);
            setSelectedPromoter(data.promoter_id);
          })
          .catch((error) => {
            console.error("Failed to fetch event data", error);
          });
      };
      getSingleEvent();
    }
    const fetchPromoters = () => {
      Axios.get("?type=promoters")
        .then((response) => {
          setPromoters(response.data); // Set promoters list
        })
        .catch((error) => {
          console.error("Failed to fetch promoters", error);
        });
    };

    fetchPromoters();

    const fetchCities = () => {
      Axios.get("?type=cities")
        .then((response) => {
          setCities(response.data); // Set cities data
        })
        .catch((error) => {
          console.error("Failed to fetch cities", error);
        });
    };
    fetchCities();
    fetchUserLocations();
  }, [id]);

  // Time change handler for MUI TimePicker
  const handleTimeChange = (newTime) => {
    if (newTime) {
      setEventTime(newTime);
      setErrors((prev) => ({ ...prev, eventTime: "" }));
    } else {
      setErrors((prev) => ({ ...prev, eventTime: "Event Time is required" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!eventTitle) newErrors.eventTitle = "Event Title is required";
    if (!eventDate) newErrors.eventDate = "Event Date is required";
    if (!eventTime)
      newErrors.eventTime = "Event Time is required";
    if (!eventAddress) newErrors.eventAddress = "Event Address is required";
    if (!eventCover && !id) newErrors.eventCover = "Event Cover image is required";
    if (!selectedCity) newErrors.selectedCity = "Country is required";
    if (!selectedPromoter) newErrors.selectedPromoter = "Promoter is required"; // Promoter validation
    if (!eventDescription) newErrors.eventDescription = "Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddOrUpdateEvent = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("event_title", eventTitle);
    formData.append("event_date", eventDate);
    formData.append("event_time", eventTime ? eventTime.format("hh:mm A") : "");
    formData.append("event_price", eventPrice);
    formData.append("venue_name", venueName);
    formData.append("event_address", eventAddress);
    formData.append("event_address_url", eventAddressUrl);
    formData.append("event_description", eventDescription);
    formData.append("city", selectedCity);
    formData.append("promoter", selectedPromoter);
    formData.append("type", "event");
    if (eventCover) {
      formData.append("event_header_image1", eventCover);
    }

    if (id) {
      formData.append("event_id", id);
    }

    Axios.post("", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        navigate(`/admin/events`);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="mainAddNewEvent">
      <div className="AddNewEvent">
        <div>
          <div className="lg:mx-12 my-2">
            <div className="text-2xl font-bold py-0 text-primary">
              {id ? "Edit Event" : "New Event"}
            </div>
            <div className="text-sm font-light py-2">Admin - Add New Events</div>
          </div>
        </div>
        <div className="addNewEventText">
          <Link to="./new">
            <MKButton>
              <Icon color="inherit">aspect_ratio</Icon>
              &nbsp; All Events
            </MKButton>
          </Link>
        </div>
      </div>
      <div className="dataTable">
        <Box sx={{ width: "100%" }} mt={5}>
          <MKBox
            position="relative"
            display="flex"
            flexDirection="column"
            borderRadius="xl"
            variant="gradient"
            bgColor="white"
            shadow="sm"
          >
            <MKBox component="section" py={0}>
              <Divider light sx={{ mx: 40, my: 2, width: "20%" }} />
              <Grid container item xs={12} lg={7} sx={{ mx: "auto" }}>
                <MKBox
                  width="100%"
                  component="form"
                  role="form"
                  autoComplete="off"
                  onSubmit={handleAddOrUpdateEvent}
                >
                  <MKBox p={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <MKInput
                          color="dark"
                          label="Event Title"
                          value={eventTitle}
                          onChange={(e) => {
                            setEventTitle(e.target.value);
                            setErrors((prevErrors) => ({ ...prevErrors, eventTitle: "" }));
                          }}
                          fullWidth
                          error={!!errors.eventTitle}
                          helpertext={errors.eventTitle}
                          formhelpertextprops={{
                            sx: { color: "red" },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <MKDatePicker
                          input={{ placeholder: "Select event date" }}
                          value={new Date(eventDate)}
                          onChange={(date) => {
                            const selectedDate = new Date(date);
                            const year = selectedDate.getFullYear();
                            const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
                            const day = String(selectedDate.getDate()).padStart(2, "0");
                            const formattedDate = `${year}-${month}-${day}`;
                            setEventDate(formattedDate);
                            // // const formattedDate = selectedDate.toISOString().split("T")[0];
                            // setEventDate(selectedDate);
                            // setErrors((prevErrors) => ({ ...prevErrors, eventDate: "" }));
                          }}
                          fullWidth
                          error={!!errors.eventDate}
                          helpertext={errors.eventDate}
                          formhelpertextprops={{
                            sx: { color: "red" },
                          }}
                        />
                        {errors.eventDate && (
                          <div className="text-xs text-red-500 mt-1 ml-4">{errors.eventDate}</div>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimeField
                            label="Event Time"
                            value={eventTime}
                            onChange={handleTimeChange}
                            format="hh:mm A"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!errors.eventTime,
                                helperText: errors.eventTime,
                                FormHelperTextProps: {
                                  sx: { color: "red" },
                                }
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      {/* <Grid item xs={12} md={12}>
                        <MKInput
                          label="Event Price (Optional)"
                          value={eventPrice}
                          onChange={(e) => {
                            setEventPrice(e.target.value);
                            setErrors((prevErrors) => ({ ...prevErrors, eventPrice: "" }));
                          }}
                          fullWidth
                        />
                      </Grid> */}

                      <Grid item xs={12} md={12}>
                        <MKInput
                          color="dark"
                          label="Venue Name"
                          value={venueName}
                          onChange={(e) => {
                            setVenueName(e.target.value);
                          }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <MKInput
                          color="dark"
                          label="Venue Address"
                          value={eventAddress}
                          onChange={(e) => {
                            setEventAddress(e.target.value);
                            setErrors((prevErrors) => ({ ...prevErrors, eventAddress: "" }));
                          }}
                          fullWidth
                          error={!!errors.eventAddress} // Set error if there is a validation issue
                          helpertext={errors.eventAddress} // Display the error message if any
                          formhelpertextprops={{
                            sx: { color: "red" },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <MKInput
                          color="dark"
                          label="Venue Location Link  (Optional)"
                          value={eventAddressUrl}
                          onChange={(e) => {
                            setEventAddressUrl(e.target.value);
                          }}
                          fullWidth
                        />
                      </Grid>
                      {/* Link to open modal of recent location list*/}
                      <div
                        className="text-sm text-purple-600 hover:underline cursor-pointer ml-4 mt-2"
                        onClick={handleOpenModal}
                      >
                        Select from recent locations
                      </div>

                      {/* Modal for recent locations */}
                      <Modal open={isModalOpen} onClose={handleCloseModal}>
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "60%",
                            maxHeight: "80%",
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                          }}
                        >
                          <Typography variant="h6" component="h2">
                            Recent Locations
                          </Typography>
                          <Box sx={{ maxHeight: "60vh", overflowY: "auto", mb: 2 }}>
                            {recentLocations?.length > 0 ? (
                              <ul>
                                {recentLocations?.map((location, index) => (
                                  <li
                                    className="flex justify-between items-center cursor-pointer bg-gray-200 shadow-sm hover:bg-gray-300 rounded-lg px-5 text-sm mt-3 py-3"
                                    key={index}
                                  >
                                    <div
                                      onClick={() => handleSelectLocation(location)}
                                      className="flex flex-col"
                                    >
                                      <span className="text-xs text-gray-500">
                                        {location.address_url}
                                      </span>
                                      <span className="font-bold mt-1">{location.address}</span>
                                      <span className="font-bold text-lg mt-1">
                                        {location.venue_name}
                                      </span>
                                    </div>
                                    <div>
                                      <div
                                        onClick={() => deleteLocation(location.id, index)}
                                        disabled={loadingDelete}
                                        className="flex text-red-600 bg-red-100 rounded-lg shadow-sm text-xs p-1 px-2 border border-red-600 ml-4"
                                      >
                                        {loadingDelete && loadingIndex == index ? (
                                          <CircularProgress size={24} color="inherit" />
                                        ) : (
                                          "Delete"
                                        )}
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <Typography variant="body1" component="p">
                                No recent locations available.
                              </Typography>
                            )}
                          </Box>
                          <Button onClick={handleCloseModal}>Close</Button>
                        </Box>
                      </Modal>

                      <Grid item xs={12} md={12}>
                        <MKInput
                          select
                          value={selectedPromoter}
                          onChange={(e) => {
                            setSelectedPromoter(e.target.value);
                            setErrors((prevErrors) => ({ ...prevErrors, selectedPromoter: "" }));
                          }}
                          fullWidth
                          error={!!errors.selectedPromoter}
                          helperText={errors.selectedPromoter}
                          SelectProps={{ native: true }}
                          FormHelperTextProps={{
                            sx: { color: "red" },
                          }}
                        >
                          <option value="" disabled>
                          Select a promoter
                          </option>
                          {promoters.map((promoter) => (
                            <option key={promoter.value} value={promoter.value}>
                              {promoter.promoter}
                            </option>
                          ))}
                        </MKInput>
                        {errors.selectedPromoter && (
                          <div className="text-xs text-red-500 mt-1 ml-4">
                            {errors.selectedPromoter}
                          </div>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        <div className="inputCoverImageDiv">
                          <Paper
                            variant="outlined"
                            className={`dropzone ${isDragging ? 'active' : ''}`}
                            sx={{
                              border: '2px dashed #ccc',
                              borderRadius: '8px',
                              padding: '20px',
                              textAlign: 'center',
                              cursor: 'pointer',
                              backgroundColor: isDragging ? 'rgba(78, 2, 73, 0.05)' : 'transparent',
                              '&:hover': {
                                backgroundColor: 'rgba(78, 2, 73, 0.05)',
                              },
                              position: 'relative',
                              minHeight: '150px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                            onDragEnter={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsDragging(true);
                            }}
                            onDragOver={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsDragging(true);
                              return false;
                            }}
                            onDragLeave={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsDragging(false);
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsDragging(false);
                              
                              const dt = e.dataTransfer;
                              if (dt.files && dt.files.length > 0) {
                                const file = dt.files[0];
                                if (file.type.startsWith('image/')) {
                                  setEventCover(file);
                                  setEventCoverPreview(URL.createObjectURL(file));
                                  setErrors((prevErrors) => ({ ...prevErrors, eventCover: '' }));
                                } else {
                                  setErrors((prevErrors) => ({ ...prevErrors, eventCover: 'Please upload an image file' }));
                                }
                              }
                              return false;
                            }}
                            onClick={() => document.getElementById('fileInput').click()}
                          >
                            {eventCoverPreview ? (
                              <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <img
                                  src={eventCoverPreview}
                                  alt="Event Cover Preview"
                                  style={{
                                    maxWidth: '100%',
                                    maxHeight: '200px',
                                    objectFit: 'contain',
                                    margin: '0 auto',
                                  }}
                                />
                                <Button
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEventCover(null);
                                    setEventCoverPreview(null);
                                  }}
                                  sx={{ position: 'absolute', top: '10px', right: '10px' }}
                                >
                                  Remove
                                </Button>
                              </div>
                            ) : (
                              <>
                                <Typography variant="body1" gutterBottom>
                                  Drag & drop an image here, or click to select
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                  Supports: JPG, PNG, GIF (max 5MB)
                                </Typography>
                              </>
                            )}
                          </Paper>
                          <input
                            type="file"
                            id="fileInput"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={(e) => {
                              if (e.target.files && e.target.files[0]) {
                                const file = e.target.files[0];
                                setEventCover(file);
                                setEventCoverPreview(URL.createObjectURL(file));
                                setErrors((prevErrors) => ({ ...prevErrors, eventCover: '' }));
                              }
                            }}
                          />
                          {errors.eventCover && (
                            <div className="text-xs text-red-500 mt-1 ml-4">
                              {errors.eventCover}
                            </div>
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <MKInput
                          select
                          label=""
                          value={selectedCity}
                          onChange={(e) => {
                            setSelectedCity(e.target.value);
                            setErrors((prevErrors) => ({ ...prevErrors, selectedCity: "" }));
                          }}
                          fullWidth
                          error={!!errors.selectedCity}
                          helpertext={errors.selectedCity}
                          SelectProps={{ native: true }}
                          formhelpertextprops={{
                            sx: { color: "red" },
                          }}
                        >
                          <option value="" disabled>
                            Select a Country
                          </option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.title}
                            </option>
                          ))}
                        </MKInput>
                      </Grid>

                      <Grid item xs={12}>
                        <ReactQuill
                          theme="snow"
                          value={eventDescription}
                          onChange={(value) => {
                            setEventDescription(value);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              eventDescription: "",
                            }));
                          }}
                          modules={{
                            toolbar: [
                              [{ header: "1" }, { header: "2" }, { font: [] }],
                              [{ list: "ordered" }, { list: "bullet" }],
                              ["bold", "italic", "underline"],
                              ["image", "code-block"],
                            ],
                          }}
                          placeholder="Write event description here..."
                        />
                        {errors.eventDescription && (
                          <div className="text-xs text-red-500 mt-1 ml-4">
                            {errors.eventDescription}
                          </div>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container item justifyContent="center" xs={12} my={2}>
                      <div className="flex gap-4 w-full">
                      <MKButton
                        variant="outlined"
                        color="dark"
                        onClick={() => navigate("/admin/events")}
                        fullWidth
                      >
                        Cancel
                      </MKButton>
                      <MKButton
                        type="submit"
                        variant="gradient"
                        color="dark"
                        fullWidth
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          `${id ? "Update Event" : "Post Event"}`
                        )}
                      </MKButton>
                      </div>
                    </Grid>
                  </MKBox>
                </MKBox>
              </Grid>
            </MKBox>
          </MKBox>
        </Box>
      </div>
    </div>
  );
}

export default AddNew;
